import { Navigate, Route, Routes } from "react-router-dom";
import { lazy, Suspense, useEffect, useState } from "react";
import ScrollToTop from "../global/ScrollToTop";

const Home = lazy(() => import("../pages/Home"));
const PortfolioPage = lazy(() => import("../pages/Portfolio"));
const ProjectDetailPage = lazy(() => import("../pages/Portfolio/slug"));
const Service = lazy(() => import("../pages/Service"));
const SubService = lazy(() => import("../pages/SubService"));
const About = lazy(() => import("../pages/About"));
const Contact = lazy(() => import("../pages/Contact"));

const Header = lazy(() => import("../global/Header"));
const Footer = lazy(() => import("../global/Footer"));

const Routing = () => {
  const [showShell, setShowShell] = useState(false);

  // Defer non-critical UI until after first paint
  useEffect(() => {
    requestAnimationFrame(() => {
      setShowShell(true);
    });
  }, []);

  return (
    <>
      {showShell && <ScrollToTop />}

      {showShell && (
        <Suspense fallback={null}>
          <Header />
        </Suspense>
      )}

      <Suspense fallback={<div className="min-h-screen" />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/portfolio/:slug" element={<ProjectDetailPage />} />
          <Route path="/services" element={<Service />} />
          <Route path="/services/:slug" element={<SubService />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact-us" element={<Contact />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Suspense>

      {showShell && (
        <Suspense fallback={null}>
          <Footer />
        </Suspense>
      )}
    </>
  );
};

export default Routing;
